<script lang="ts" setup>
import { NScrollbar } from 'naive-ui'

defineProps<{
  placement?: any
}>()
const { data: stickerList } = await useAsyncData(
  'stickerList',
  () => fetchStickerList(),
  {
    default: () => [] as StickerList[]
  }
)

const emit = defineEmits<{
  (e: 'submit', value: string): void
}>()
const currentStickerList = ref(stickerList.value[0]?.name)
const options = [
  {
    key: 'stickerList',
    type: 'render',
    render: renderStickerList
  }
]
function renderStickerList() {
  return h(
    'div',
    {
      class: 'm-sticker__container'
    },
    [
      h(
        NScrollbar,
        {
          class: 'm-sticker__menu'
        },
        {
          default: () =>
            stickerList.value?.map((s) => {
              return h(
                'div',
                {
                  key: s.name,
                  class:
                    currentStickerList.value === s.name
                      ? 'active m-sticker__menu-item'
                      : 'm-sticker__menu-item',
                  onClick() {
                    currentStickerList.value = s.name
                  }
                },
                s.name
              )
            })
        }
      ),
      h(
        'div',
        {
          class: 'm-sticker__list'
        },
        {
          default: () =>
            stickerList.value
              .find((s) => s.name === currentStickerList.value)
              ?.list?.map((s) => {
                return h(
                  'div',
                  {
                    class: 'm-sticker__item'
                  },
                  [
                    h('img', {
                      key: s.name,
                      src: s.url,
                      class: 'm-sticker__img',
                      onClick() {
                        emit('submit', s.name)
                      }
                    }),
                    h(
                      'span',
                      {
                        class: 'm-sticker__label'
                      },
                      s.desc
                    )
                  ]
                )
              })
        }
      )
    ]
  )
}
</script>

<template>
  <n-dropdown
    :options="options"
    :placement="placement || 'bottom-start'"
    trigger="click"
  >
    <slot />
  </n-dropdown>
</template>

<style lang="scss">
.m-sticker {
  &__container {
    display: flex;
  }
  &__menu {
    height: 200px;
    max-height: 200px;
    width: 120px;
    border-right: 1px solid var(--color-gray-200);
    &-item {
      cursor: pointer;
      padding: 4px;
      margin: 4px;
      font-size: 12px;
      border-radius: 4px;
    }
    .active {
      background-color: var(--color-primary);
      color: #fff;
    }
  }
  &__list {
    max-height: 200px;
    overflow-y: auto;
    padding: 8px;
    display: grid;
    gap: 8px;
    grid-template-columns: repeat(4, 1fr);
  }
  &__item {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80px;
    height: 80px;
  }
  &__img {
    width: 60px;
    height: 60px;
  }
  &__label {
    font-size: 12px;
    color: var(--color-gray-400);
  }
}
</style>
